import React from "react";
import PhoneInput from "react-phone-number-input";

const CustomPhoneInput = ({ value, onChange, onBlur, defaultCountry = "AU", placeholder = "Enter phone number" }) => {
  return (
    <div className="pte-consultation__phone">
      <PhoneInput
        defaultCountry={defaultCountry}
        international
        countryCallingCodeEditable={false}
        placeholder={placeholder}
        value={value}
        onChange={(val) => onChange(val || "")}
        onBlur={onBlur}
      />
    </div>
  );
};

export default CustomPhoneInput;
